export const LOW_MARGIN_THRESHOLD = 10;

export const EMPTY_STATE_MESSAGE = "Please select a client to view pricing data";

export const NO_ITEMS_MESSAGE = "There are no pricing data matching this criteria";
